import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    flexGrow: 1,
    background: 'black',
    color: '#f5f5f7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const Loading = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>Loading...</div>
    </div>
  )
}

export default Loading
